import React from 'react';
import styled, { css, keyframes } from 'styled-components';

const LoadingKeyframe = keyframes`
  to {
    background-position: 350% 0, 24px 180px;
  }
`;

const ShiningSkeletonBox = styled.div<{ width: number; height: number; stretch?: boolean }>`
    width: ${({ width }) => `${width}px`};
    height: ${({ height }) => `${height}px`};

    ${({ stretch }) =>
        stretch &&
        css`
            width: 100%;
        `}

    &:after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), white, rgba(255, 255, 255, 0));
        background-size: ${({ width, height }) => `${width * 0.5}px ${height}px, ${width}px ${height}px`};
        background-position: -150% 0, 24px 180px;
        background-repeat: no-repeat;
        background-color: ${({ theme: { colors } }) => colors.charcoal3};
        animation: ${LoadingKeyframe} 1.2s infinite;
    }
`;

const Wrapper = styled.div`
    display: grid;
    grid-template:
        'image  .   info' 120px
        '.      .   .' 20px
        / 84px 12px 1fr;
    margin-top: 20px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.charcoal20};
`;

const ProductImageSkeleton = styled(ShiningSkeletonBox)`
    grid-area: image;
`;

const ProductTitleSkeleton = styled(ShiningSkeletonBox)`
    grid-area: title;
    margin-bottom: 2px;
`;

const ProductSizeSkeleton = styled(ShiningSkeletonBox)`
    margin-bottom: 2px;
`;

const PriceSkeleton = styled(ShiningSkeletonBox)`
    margin-bottom: 17px;
`;

const QuantitySelectorSkeleton = styled(ShiningSkeletonBox)`
    margin-right: 10px;
`;

const ActionButtonSkeleton = styled(ShiningSkeletonBox)``;

const ProductInformation = styled.div`
    grid-area: info;
    display: flex;
    flex-direction: column;
`;

const ActionButtonsWrapper = styled.div`
    display: flex;
`;

const AddOnProductTileSkeleton = () => (
    <Wrapper>
        <ProductImageSkeleton height={120} width={84} />
        <ProductInformation>
            <ProductTitleSkeleton height={18} width={100} stretch />
            <ProductSizeSkeleton height={18} width={100} stretch />
            <PriceSkeleton height={20} width={50} />
            <ActionButtonsWrapper>
                <QuantitySelectorSkeleton height={36} width={66} />
                <ActionButtonSkeleton height={36} stretch width={100} />
            </ActionButtonsWrapper>
        </ProductInformation>
    </Wrapper>
);

export default AddOnProductTileSkeleton;
